import React from 'react'
import Tabs from '../../../Tabs'
import UbliqueColumn from '../Column'
import UbliqueRow from '../Row'
import * as pagesMap from '../../index'
import cn from 'classnames'

import './index.scss'

const StripeTabs = ({ tabs, onTabChange, className = '' }) => {
  return (
    <UbliqueRow className='ublique-tabs-row'>
      <UbliqueColumn>
        <Tabs onTabChange={onTabChange}>
          {tabs.map(({ page, tabTitle, pageConfig }, idx) => {
            const Page = pagesMap[page] || pagesMap.PageCustom
            return (
              <Tabs.Tab key={`page-output-stripe-tab-${idx}`} title={tabTitle}>
                <Page
                  {...pageConfig}
                  className={cn('tab-content-page', className)}
                />
              </Tabs.Tab>
            )
          })}
        </Tabs>
      </UbliqueColumn>
    </UbliqueRow>
  )
}

export default StripeTabs
